<template>
  <div class="bill-detail-page">
    <!-- 顶部工具栏 -->
    <div class="top-toolbar">
      <div class="breadcrumb">账单详情{{ routeParams.month ? ` - ${routeParams.month}` : '' }}</div>
      <div class="date-controls">
        <el-date-picker
          v-model="startDate"
          type="date"
          placeholder="2025-09-01"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          size="small"
        />
        <span class="date-separator">至</span>
        <el-date-picker
          v-model="endDate"
          type="date"
          placeholder="2025-09-11"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          size="small"
        />
        <el-button type="primary" size="small">查询</el-button>
      </div>
    </div>


    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 图表区域 - 整体容器 -->
      <div class="charts-section">
        <!-- 左侧饼图区域 -->
        <div class="left-charts">
          <div class="chart-item">
            <div class="pie-chart-header">服务费用占比</div>
            <div ref="pieChart" class="pie-chart"></div>
            <div class="pie-info">
              <div class="pie-stats">
                <div 
                  class="stat-item charge"
                  :class="{ active: selectedStatType === 'charge' }"
                  @click="switchStatType('charge')"
                >
                  <div class="stat-label">Charge:</div>
                  <div class="stat-value">¥{{ statsData.charge }}</div>
                </div>
                <div 
                  class="stat-item cost"
                  :class="{ active: selectedStatType === 'cost' }"
                  @click="switchStatType('cost')"
                >
                  <div class="stat-label">实际花费:</div>
                  <div class="stat-value">¥{{ statsData.cost }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- 右侧柱状图区域 -->
        <div class="right-content">
          <div class="entity-cost-header">
            <span class="entity-cost-title">子实体费用</span>
            <div class="entity-cost-actions">
              <el-button
                size="small"
                :type="entityCostVisibility.charge ? 'primary' : ''"
                @click="toggleEntityCost('charge')"
              >
                Charge
              </el-button>
              <el-button
                size="small"
                :type="entityCostVisibility.totalCost ? 'warning' : ''"
                @click="toggleEntityCost('totalCost')"
                class="orange-button"
              >
                实际花费
              </el-button>
            </div>
          </div>
          <div class="bar-chart-container">
            <el-scrollbar :height="chartScrollHeight">
              <div ref="barChart" class="bar-chart" :style="{ height: dynamicChartHeight }"></div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>

    <!-- 实体统计表格 -->
    <div class="entity-stats-section">
      <div class="section-header">
        <h3>link费用统计</h3>
      </div>
      <div class="stats-table-container">
        <el-table 
          :data="entityStatsData" 
          style="width: 100%"
          :show-header="true"
          size="small"
          max-height="400"
        >
          <el-table-column prop="payerName" label="PayerName" align="center" min-width="120"></el-table-column>
          <el-table-column prop="payerId" label="PayerId" align="center" min-width="130"></el-table-column>
          <el-table-column prop="linkId" label="LinkId" align="center" min-width="130"></el-table-column>
          <el-table-column prop="linkName" label="LinkName" align="center" min-width="120"></el-table-column>
          <el-table-column prop="charge" label="Charge" align="center" min-width="110">
            <template #default="scope">¥{{ scope.row.charge.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="credit" label="Credit" align="center" min-width="110">
            <template #default="scope">¥{{ scope.row.credit.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="discount" label="Discount" align="center" min-width="110">
            <template #default="scope">¥{{ scope.row.discount.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="tax" label="Tax" align="center" min-width="100">
            <template #default="scope">¥{{ scope.row.tax.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="savingPlan" label="SavingPlan" align="center" min-width="110">
            <template #default="scope">¥{{ scope.row.savingPlan.toFixed(2) }}</template>
          </el-table-column>python manage.py runserver 127.0.0.1:8000

          <el-table-column prop="bundle" label="Bundle" align="center" min-width="100">
            <template #default="scope">¥{{ scope.row.bundle.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column prop="totalCost" label="TotalCost" align="center" min-width="110">
            <template #default="scope">¥{{ scope.row.totalCost.toFixed(2) }}</template>
          </el-table-column>
        </el-table>
        <div class="total-row">
          <span>{{ entityStatsData.length }} total</span>
        </div>
      </div>
    </div>

    <!-- 详细数据表格 -->
    <div class="detail-data-section">
      <!-- 筛选区域 -->
      <div class="filter-section">
        <div class="filter-left">
          <el-dropdown trigger="click" placement="bottom-start">
            <span class="dropdown-trigger">
              <span class="filter-label">按资源类别</span>
              <el-icon class="filter-icon"><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu class="column-filter-dropdown">
                <div class="filter-checkboxes">
                  <el-checkbox v-model="filters.all" @change="handleFilterAll">全选</el-checkbox>
                  <el-checkbox v-model="filters.service" @change="handleFilterChange">服务</el-checkbox>
                  <el-checkbox v-model="filters.serviceCategory" @change="handleFilterChange">服务分类</el-checkbox>
                  <el-checkbox v-model="filters.resourceGroup" @change="handleFilterChange">资源组</el-checkbox>
                  <el-checkbox v-model="filters.unit" @change="handleFilterChange">度量单位</el-checkbox>
                  <el-checkbox v-model="filters.consumedQuantity" @change="handleFilterChange">已消耗数量</el-checkbox>
                  <el-checkbox v-model="filters.webDirectBilling" @change="handleFilterChange">WebDirect计费</el-checkbox>
                  <el-checkbox v-model="filters.webDirectPrice" @change="handleFilterChange">WebDirect单价</el-checkbox>
                </div>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="filter-right">
          <el-button size="small" type="text" @click="showDownloadDialog">下载</el-button>
        </div>
      </div>

      <!-- 详细数据表格 -->
      <div class="detail-table-container">
        <el-table 
          :data="detailTableData" 
          style="width: 100%"
          :show-header="true"
          size="small"
          max-height="500"
        >
          <el-table-column prop="entityName" label="实体" align="center" width="200"></el-table-column>
          <el-table-column 
            v-if="filters.service" 
            prop="serviceName" 
            label="服务" 
            min-width="300"
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.serviceCategory" 
            prop="serviceCategory" 
            label="服务分类" 
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.resourceGroup" 
            prop="resourceGroup" 
            label="资源组" 
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.unit" 
            prop="unit" 
            label="度量单位" 
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.consumedQuantity" 
            prop="consumedQuantity" 
            label="已消耗数量" 
            min-width="100" 
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.webDirectBilling" 
            prop="webDirectBilling" 
            label="WebDirect计费" 
            min-width="120" 
            align="center"
          ></el-table-column>
          <el-table-column 
            v-if="filters.webDirectPrice" 
            prop="webDirectPrice" 
            label="WebDirect单价" 
            min-width="120" 
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="table-pagination">
        <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          layout="total, prev, pager, next, jumper"
          size="small"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <!-- 下载弹窗 -->
    <el-dialog
      v-model="downloadDialogVisible"
      title="下载账单"
      width="500px"
      :before-close="handleDownloadClose"
    >
      <el-form :model="downloadForm" label-width="80px">
        <el-form-item label="实体名称">
          <el-input v-model="downloadForm.entityName" placeholder="元一数码(北京)技术有限公司" />
        </el-form-item>
        
        <el-form-item label="账单周期">
          <div style="display: flex; align-items: center; gap: 10px;">
            <el-date-picker
              v-model="downloadForm.startDate"
              type="date"
              placeholder="2025-04-01"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="flex: 1;"
            />
            <span>-</span>
            <el-date-picker
              v-model="downloadForm.endDate"
              type="date"
              placeholder="2025-04-30"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="flex: 1;"
            />
          </div>
        </el-form-item>
        
        <el-form-item label="报告格式">
          <el-select v-model="downloadForm.reportFormat" placeholder="请选择报告格式">
            <el-option label="PDF" value="pdf"></el-option>
            <el-option label="Excel" value="excel"></el-option>
            <el-option label="CSV" value="csv"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="计费方式">
          <el-select v-model="downloadForm.billingMethod" placeholder="请选择计费方式">
            <el-option label="套餐计费" value="package"></el-option>
            <el-option label="WebDirect计费" value="webdirect"></el-option>
            <el-option label="全部计费方式" value="all"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleDownloadClose">取消</el-button>
          <el-button type="primary" @click="handleDownloadConfirm">提交</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { ArrowDown } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { getBillList, getProductAggregation, getPayerList, getBillSumList, getLinkerList } from '@/api/api'

export default {
  name: 'BillDetail',
  components: {
    ArrowDown
  },
  props: {
    params: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      startDate: '2025-09-01',
      endDate: '2025-09-11',
      pieChartInstance: null,
      barChartInstance: null,
      selectedStatType: 'charge',
      // 实体费用柱状图可见性（默认显示charge）
      entityCostVisibility: {
        charge: true,
        totalCost: false
      },
      // 实体费用数据
      entityCostData: {
        entities: [],
        chargeData: [],
        totalCostData: []
      },
      // 图表滚动高度
      chartScrollHeight: '350px',
      // payer映射表
      payerMap: new Map(),
      // linker映射表
      linkerMap: new Map(),
      // billType（从路由参数获取）
      billType: 1,
      // 从路由参数获取的数据
      routeParams: {
        month: '',
        nodeType: '',
        nodeId: ''
      },
      // 统计数据
      statsData: {
        charge: '0.00',
        cost: '0.00',
        pieData: []
      },
      // 实体统计数据
      entityStatsData: [],
      // 筛选器状态
      filters: {
        all: true,
        service: true,
        serviceCategory: true,
        resourceGroup: true,
        unit: true,
        consumedQuantity: true,
        webDirectBilling: true,
        webDirectPrice: true
      },
      // 详细表格数据
      detailTableData: [
        {
          entityName: '持牌公司',
          serviceName: 'Application Gateway Standard v2 - Fixed Cost - CN North 3',
          serviceCategory: 'microsoft.network',
          resourceGroup: '/Hour',
          unit: '/Hour',
          consumedQuantity: '1.5068',
          webDirectBilling: '0.12',
          webDirectPrice: ''
        },
        {
          entityName: '持牌公司',
          serviceName: 'Application Gateway Standard v2 - Fixed Cost - CN North 3',
          serviceCategory: 'microsoft.network',
          resourceGroup: '/Hour',
          unit: '/Hour',
          consumedQuantity: '1.4633',
          webDirectBilling: '2.98',
          webDirectPrice: ''
        },
        {
          entityName: '持牌公司',
          serviceName: 'Application Gateway WAF v2 - Standard Capacity Units - CN North 3',
          serviceCategory: 'microsoft.network',
          resourceGroup: '/Hour',
          unit: '/Hour',
          consumedQuantity: '305.7691',
          webDirectBilling: '44.95',
          webDirectPrice: ''
        },
        {
          entityName: '元一数码(北京)技术有限公司',
          serviceName: 'Application Gateway WAF v2 - Standard Fixed Cost - CN North 3',
          serviceCategory: 'microsoft.network',
          resourceGroup: '/Hour',
          unit: '/Hour',
          consumedQuantity: '306',
          webDirectBilling: '1120.88',
          webDirectPrice: ''
        }
      ],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      totalRecords: 534,
      // 下载弹窗相关
      downloadDialogVisible: false,
      downloadForm: {
        entityName: '元一数码(北京)技术有限公司',
        startDate: '2025-04-01',
        endDate: '2025-04-30',
        reportFormat: 'pdf',
        billingMethod: 'package'
      }
    }
  },
  computed: {
    // 动态计算图表高度，每个实体30px，最小350px
    dynamicChartHeight() {
      const entityCount = this.entityCostData.entities.length
      const minHeight = 350
      const calculatedHeight = entityCount * 30
      return `${Math.max(minHeight, calculatedHeight)}px`
    }
  },
  async mounted() {
    // 优先使用props参数，其次使用路由参数
    if (this.params) {
      this.routeParams.month = this.params.month || ''
      this.routeParams.nodeType = this.params.nodeType || ''
      this.routeParams.nodeId = this.params.nodeId || ''
      this.billType = this.params.billType || 1
    } else {
      this.routeParams.month = this.$route.query.month || ''
      this.routeParams.nodeType = this.$route.query.nodeType || ''
      this.routeParams.nodeId = this.$route.query.nodeId || ''
      this.billType = parseInt(this.$route.query.billType) || 1
    }
    
    console.log('详情页面接收到的参数:', this.routeParams, 'billType:', this.billType)
    
    // 加载payer和linker列表
    await this.loadPayerList()
    await this.loadLinkerList()
    
    // 加载数据
    this.loadBillData()
    
    // 延迟初始化图表，确保DOM完全渲染
    setTimeout(() => {
      this.initPieChart()
      this.initBarChart()
    }, 100)
  },
  beforeUnmount() {
    if (this.pieChartInstance) {
      this.pieChartInstance.dispose()
      this.pieChartInstance = null
    }
    if (this.barChartInstance) {
      this.barChartInstance.dispose()
      this.barChartInstance = null
    }
  },
  methods: {
    // 加载payer列表
    async loadPayerList() {
      try {
        const res = await getPayerList({ page: 1, limit: 999999 })
        if (res.code === 2000 && res.data) {
          const payers = res.data.data || res.data
          payers.forEach(payer => {
            this.payerMap.set(payer.payer_id, payer.name)
          })
        }
      } catch (error) {
        console.error('加载payer列表失败:', error)
      }
    },
    
    // 加载linker列表
    async loadLinkerList() {
      try {
        const res = await getLinkerList({ page: 1, limit: 999999 })
        if (res.code === 2000 && res.data) {
          const linkers = res.data.data || res.data
          linkers.forEach(linker => {
            this.linkerMap.set(linker.link_id, linker.customer_name || linker.name || linker.link_id)
          })
        }
      } catch (error) {
        console.error('加载linker列表失败:', error)
      }
    },
    
    // 加载账单数据
    async loadBillData() {
      if (!this.routeParams.month) return
      
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = currentDate.getMonth() + 1
      const currentMonthStr = `${currentYear}${String(currentMonth).padStart(2, '0')}`
      
      // 解析路由中的月份
      const [year, month] = this.routeParams.month.split('-')
      const queryMonthStr = `${year}${month}`
      
      // 判断是否为当月
      const isCurrentMonth = queryMonthStr === currentMonthStr
      
      try {
        // 加载饼图数据
        await this.loadPieData(isCurrentMonth, queryMonthStr)
        // 加载实体费用数据
        await this.loadEntityCostData(queryMonthStr)
        // 加载实体统计数据
        await this.loadEntityStatsData(queryMonthStr)
      } catch (error) {
        console.error('加载账单数据失败:', error)
        ElMessage.error('加载数据失败')
      }
    },
    
    // 加载实体统计数据
    async loadEntityStatsData(month) {
      const params = {
        month: month,
        billType: this.billType
      }
      
      // 根据节点类型构建参数
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        params.agent_id = this.routeParams.nodeId
      }
      
      console.log('加载实体统计数据，参数:', params)
      
      try {
        const res = await getBillSumList(params)
        console.log('实体统计数据响应:', res)
        
        if (res.code === 2000 && res.data) {
          this.entityStatsData = res.data
          console.log('实体统计数据已设置:', this.entityStatsData)
        } else {
          console.error('实体统计数据响应异常:', res)
        }
      } catch (error) {
        console.error('加载实体统计数据失败:', error)
      }
    },
    
    // 加载实体费用数据
    async loadEntityCostData(month) {
      const params = { month: month }
      
      // 根据节点类型构建参数
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        params.agent_id = this.routeParams.nodeId
      }
      
      try {
        params.page = 1
        params.limit = 999999
        const res = await getBillList(params)
        
        if (res.code === 2000 && res.data) {
          const billData = Array.isArray(res.data.data) ? res.data.data : res.data
          
          // 根据节点类型聚合数据
          const aggregateMap = {}
          
          billData.forEach(bill => {
            let entityKey = ''
            if (this.routeParams.nodeType === 'agent') {
              // agent节点：按payer聚合，显示payer名称
              const payerId = bill.payerId || bill.payer_id || '未知Payer'
              const payerName = this.payerMap.get(payerId) || payerId
              entityKey = `${payerName}:`
            } else if (this.routeParams.nodeType === 'payer') {
              // payer节点：按link聚合
              const linkId = bill.linkId || bill.link_id || '未知Link'
              entityKey = `Link: ${linkId}`
            } else {
              // link节点：就是自己
              const linkId = bill.linkId || bill.link_id || this.routeParams.nodeId
              entityKey = `Link: ${linkId}`
            }
            
            if (!aggregateMap[entityKey]) {
              aggregateMap[entityKey] = {
                entity: entityKey,
                charge: 0,
                totalCost: 0
              }
            }
            aggregateMap[entityKey].charge += Number(bill.charge) || 0
            aggregateMap[entityKey].totalCost += Number(bill.costTotal) || 0
          })
          
          // 转换为数组并按当前显示类型降序排列
          const sortedData = Object.values(aggregateMap).sort((a, b) => {
            // 根据当前显示的类型排序
            if (this.entityCostVisibility.charge) {
              return b.charge - a.charge
            } else {
              return b.totalCost - a.totalCost
            }
          })
          
          // 反转数组，使横向柱状图从上到下显示从高到低
          this.entityCostData = {
            entities: sortedData.map(item => item.entity).reverse(),
            chargeData: sortedData.map(item => parseFloat(item.charge.toFixed(2))).reverse(),
            totalCostData: sortedData.map(item => parseFloat(item.totalCost.toFixed(2))).reverse()
          }
        }
        
        // 更新柱状图
        this.$nextTick(() => {
          this.updateBarChart()
        })
      } catch (error) {
        console.error('加载实体费用数据失败:', error)
      }
    },
    
    // 加载饼图数据
    async loadPieData(isCurrentMonth, month) {
      // 根据节点类型构建查询参数
      const params = {
        month: month
      }
      
      // 根据节点类型添加不同的参数
      if (this.routeParams.nodeType === 'link') {
        params.link_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'payer') {
        params.payer_id = this.routeParams.nodeId
      } else if (this.routeParams.nodeType === 'agent') {
        params.agent_id = this.routeParams.nodeId
      }
      
      let pieData = []
      
      // 调用产品聚合API
      const res = await getProductAggregation(params)
      
      if (res.code === 2000 && res.data) {
        pieData = res.data.map(item => ({
          name: item.productName,
          charge: item.charge,
          costTotal: item.costTotal
        }))
      }
      
      // 计算总计
      let totalCharge = 0
      let totalCost = 0
      pieData.forEach(item => {
        totalCharge += item.charge
        totalCost += item.costTotal
      })
      
      this.statsData.charge = totalCharge.toFixed(2)
      this.statsData.cost = totalCost.toFixed(2)
      this.statsData.pieData = pieData
      
      // 更新饼图
      this.$nextTick(() => {
        this.updatePieChart()
      })
    },
    
    // 切换统计类型
    switchStatType(type) {
      this.selectedStatType = type
      this.$nextTick(() => {
        this.updatePieChart()
      })
    },
    
    // 初始化饼图
    initPieChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.pieChart
        if (chartDom) {
          this.pieChartInstance = echarts.init(chartDom)
          this.updatePieChart()
        }
      })
    },
    
    // 更新饼图
    updatePieChart() {
      if (!this.pieChartInstance) return
      
      const pieData = this.statsData.pieData || []
      const colors = ['#5ca3db', '#70AD47', '#f7941d', '#ee6c6c', '#9f7aea', '#48c9b0', '#f39c12', '#e74c3c', '#3498db', '#9b59b6']
      
      // 根据选中的类型过滤和映射数据
      const filteredData = pieData
        .filter(item => {
          const value = this.selectedStatType === 'charge' ? item.charge : item.costTotal
          return value > 0
        })
        .map((item, index) => ({
          name: item.name,
          value: this.selectedStatType === 'charge' ? item.charge : item.costTotal,
          itemStyle: { color: colors[index % colors.length] }
        }))
      
      const hasData = filteredData.length > 0
      const seriesName = this.selectedStatType === 'charge' ? 'Charge占比' : '实际花费占比'
      
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : ¥{c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: seriesName,
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: hasData,
              position: 'outside',
              formatter: '{b}\n¥{c}\n{d}%',
              fontSize: 11
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              }
            },
            data: hasData ? filteredData : []
          }
        ]
      }
      
      this.pieChartInstance.setOption(option)
    },

    // 初始化柱状图
    initBarChart() {
      this.$nextTick(() => {
        const chartDom = this.$refs.barChart
        if (chartDom) {
          this.barChartInstance = echarts.init(chartDom)
          this.updateBarChart()
        }
      })
    },
    
    // 更新柱状图
    updateBarChart() {
      if (!this.barChartInstance) return
      
      const entityCount = this.entityCostData.entities.length
      const showLabel = entityCount <= 15
      
      // 只显示当前选中的类型
      const series = this.entityCostVisibility.charge ? [{
        name: 'Charge',
        type: 'bar',
        data: this.entityCostData.chargeData,
        itemStyle: { color: '#409EFF' },
        barWidth: 18,
        label: {
          show: showLabel,
          position: 'right',
          fontSize: 10,
          color: '#409EFF',
          formatter: '¥{c}'
        }
      }] : [{
        name: '实际花费',
        type: 'bar',
        data: this.entityCostData.totalCostData,
        itemStyle: { color: '#ff7f50' },
        barWidth: 18,
        label: {
          show: showLabel,
          position: 'right',
          fontSize: 10,
          color: '#ff7f50',
          formatter: '¥{c}'
        }
      }]
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          left: '20%',
          right: '15%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          show: false
        },
        yAxis: {
          type: 'category',
          data: this.entityCostData.entities,
          axisLabel: {
            color: '#303133',
            fontSize: 10,
            fontWeight: 500
          },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: series
      }
      
      this.barChartInstance.setOption(option, true)
    },
    
    // 切换实体费用显示（互斥）
    toggleEntityCost(type) {
      if (type === 'charge') {
        this.entityCostVisibility.charge = true
        this.entityCostVisibility.totalCost = false
      } else if (type === 'totalCost') {
        this.entityCostVisibility.charge = false
        this.entityCostVisibility.totalCost = true
      }
      // 重新加载数据以重新排序
      const [year, month] = this.routeParams.month.split('-')
      const queryMonthStr = `${year}${month}`
      this.loadEntityCostData(queryMonthStr)
    },

    // 处理全选筛选
    handleFilterAll(value) {
      Object.keys(this.filters).forEach(key => {
        if (key !== 'all') {
          this.filters[key] = value
        }
      })
    },

    // 处理单个筛选项变化
    handleFilterChange() {
      const filterKeys = Object.keys(this.filters).filter(key => key !== 'all')
      const allChecked = filterKeys.every(key => this.filters[key])
      const someChecked = filterKeys.some(key => this.filters[key])
      
      if (allChecked) {
        this.filters.all = true
      } else if (!someChecked) {
        this.filters.all = false
      } else {
        this.filters.all = false
      }
    },

    // 显示下载弹窗
    showDownloadDialog() {
      this.downloadDialogVisible = true
    },

    // 关闭下载弹窗
    handleDownloadClose() {
      this.downloadDialogVisible = false
    },

    // 确认下载
    handleDownloadConfirm() {
      console.log('下载表单数据:', this.downloadForm)
      // 这里可以添加实际的下载逻辑
      this.$message.success('下载请求已提交，请稍候...')
      this.downloadDialogVisible = false
    },

    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page
      console.log('当前页码:', page)
      // 这里可以添加重新加载数据的逻辑
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-detail-page {
  min-height: 100vh;
  background: #f5f6fa;
  padding: 0;
  margin: 0;
  padding-bottom: 60px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 顶部工具栏 */
.top-toolbar {
  background: #ffffff;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.breadcrumb {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  display: flex;
  align-items: center;
  
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
    margin-right: 8px;
    border-radius: 2px;
  }
}

.date-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .el-button {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 4px;
    
    &.el-button--primary {
      background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
      border: none;
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
      
      &:hover {
        background: linear-gradient(135deg, #66b3ff 0%, #409eff 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.4);
      }
    }
  }
}

.date-separator {
  margin: 0 5px;
  color: #909399;
  font-size: 12px;
}

/* 主要内容区域 */
.main-content {
  padding: 20px 0;
  max-width: 1400px;
  margin: 0 auto;
}

/* 图表区域整体容器 */
.charts-section {
  display: flex;
  gap: 0;
  background: #ffffff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

/* 左侧图表区域 */
.left-charts {
  flex: 1;
  display: flex;
  width: 50%;
  flex-direction: column;
}

.chart-item {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  width: 100%;
  min-height: 400px;
}

.pie-chart-header {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding: 16px 0 0 0;
}

.pie-chart {
  height: 300px;
  min-height: 300px;
  padding: 10px 20px;
  width: 100%;
}

.pie-info {
  padding: 16px 20px 20px;
  border-top: 1px solid #e8eaec;
  background: #fafbfc;
}

.pie-stats {
  display: flex;
  gap: 12px;
  justify-content: center;
  
  .stat-item {
    flex: 1;
    padding: 12px;
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    &.active::after {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border: 2px solid;
      border-radius: 8px;
      pointer-events: none;
    }
    
    &.charge {
      border: 1px solid #1890ff;
      background: #f0f8ff;
      
      &.active::after {
        border-color: #1890ff;
      }
      
      .stat-value {
        color: #1890ff;
      }
    }
    
    &.cost {
      border: 1px solid #ff7f50;
      background: #fff5f0;
      
      &.active::after {
        border-color: #ff7f50;
      }
      
      .stat-value {
        color: #ff7f50;
      }
    }
    
    .stat-label {
      font-size: 12px;
      color: #606266;
      margin-bottom: 4px;
    }
    
    .stat-value {
      font-size: 16px;
      font-weight: 600;
    }
  }
}

/* 右侧柱状图区域 */
.right-content {
  width: 50%;
  flex: 1;
  background: transparent;
  border: none;
  border-left: 1px solid #e8eaec;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.entity-cost-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eaec;
  background: #fafbfc;
  
  .entity-cost-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }
  
  .entity-cost-actions {
    display: flex;
    gap: 8px;
    
    .orange-button.el-button--warning {
      --el-button-bg-color: #ff7f50;
      --el-button-border-color: #ff7f50;
      --el-button-hover-bg-color: #ff9770;
      --el-button-hover-border-color: #ff9770;
    }
  }
}

.bar-chart-container {
  flex: 1;
  width: 100%;
  position: relative;
}

.bar-chart {
  width: 100%;
  padding: 20px;
}

/* 实体统计表格样式 */
.entity-stats-section {
  margin: 0 0 20px;
  background: #ffffff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  max-width: 1400px;
  margin: 0 auto 20px;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.section-header {
  padding: 16px 20px;
  background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
  border-bottom: 1px solid #e8eaec;
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
    border-radius: 2px;
  }
  
  h3 {
    margin: 0;
    padding-left: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
}

.stats-table-container {
  padding: 0;
}

.total-row {
  padding: 12px 20px;
  font-size: 12px;
  color: #909399;
  border-top: 1px solid #e8eaec;
  background: #fafbfc;
  text-align: left;
  font-weight: 500;
}

/* 详细数据表格样式 */
.detail-data-section {
  background: #ffffff;
  border: 1px solid #e8eaec;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  max-width: 1400px;
  margin: 0 auto 20px;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

.filter-section {
  padding: 16px 20px;
  background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
  border-bottom: 1px solid #e8eaec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
    border-radius: 2px;
  }
}

.filter-left {
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 12px;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid transparent;
  
  &:hover {
    background: #ffffff;
    border-color: #409eff;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    transform: translateY(-1px);
  }
}

.filter-label {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
}

.filter-icon {
  color: #909399;
  font-size: 12px;
  transition: all 0.3s ease;
  
  .dropdown-trigger:hover & {
    color: #409eff;
    transform: rotate(180deg);
  }
}

.filter-right {
  display: flex;
  gap: 8px;
  
  .el-button {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    
    &.el-button--text {
      color: #409eff;
      
      &:hover {
        background: rgba(64, 158, 255, 0.1);
        color: #409eff;
      }
    }
  }
}

/* 下拉菜单样式 */
.column-filter-dropdown{
  padding: 12px;
  min-width: 220px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e8eaec;
}

.filter-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-table-container {
  padding: 0;
}

.table-pagination {
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #e8eaec;
  background: #fafbfc;
}

/* Element Plus 表格样式优化 */
:deep(.el-table) {
  font-size: 12px;
  --el-table-border-color: #e8eaec;
  --el-table-header-bg-color: #fafbfc;
  --el-table-row-hover-bg-color: #f0f8ff;
}

:deep(.el-table th) {
  background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
  font-weight: 600;
  color: #303133;
  font-size: 12px;
  padding: 12px 0;
  border-bottom: 2px solid #e8eaec;
}

:deep(.el-table td) {
  padding: 10px 0;
  font-size: 12px;
  color: #606266;
  border-bottom: 1px solid #f0f2f5;
}

:deep(.el-table .cell) {
  padding: 0 12px;
  line-height: 1.5;
}

:deep(.el-table tr:hover > td) {
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f4ff 100%);
}

:deep(.el-table--border) {
  border: none;
}

:deep(.el-table--border::after) {
  display: none;
}

:deep(.el-table tbody tr) {
  transition: all 0.2s ease;
}

:deep(.el-table tbody tr:last-child td) {
  border-bottom: none;
}

/* 复选框样式 */
:deep(.el-checkbox) {
  font-size: 12px;
  margin-bottom: 2px;
  
  .el-checkbox__input {
    .el-checkbox__inner {
      border-radius: 4px;
      border-color: #d9d9d9;
      
      &:hover {
        border-color: #409eff;
      }
    }
    
    &.is-checked .el-checkbox__inner {
      background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
      border-color: #409eff;
    }
  }
  
  .el-checkbox__label {
    color: #606266;
    font-weight: 500;
    font-size: 12px;
    
    &:hover {
      color: #409eff;
    }
  }
}

/* 日期选择器样式 */
:deep(.el-date-editor.el-input) {
  width: 120px;
  
  .el-input__wrapper {
    border-radius: 6px;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 0 0 1px #c0c4cc inset;
    }
    
    &.is-focus {
      box-shadow: 0 0 0 1px #409eff inset;
    }
  }
  
  .el-input__inner {
    font-size: 12px;
    color: #606266;
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .charts-section {
    flex-direction: column;
  }
  
  .left-charts {
    width: 100%;
  }
  
  .right-content {
    border-left: none;
    border-top: 1px solid #e8eaec;
  }
}

@media (max-width: 768px) {
  .top-toolbar {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .main-content {
    padding: 10px;
  }
  
  .entity-stats-section,
  .detail-data-section {
    margin: 0 10px 10px;
  }
  }
  
  /* 下载弹窗样式 */
  :deep(.el-dialog) {
    border-radius: 8px;
    
    .el-dialog__header {
      background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
      padding: 20px 24px;
      border-bottom: 1px solid #e8eaec;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      border-top: 1px solid #e8eaec;
      background: #fafbfc;
    }
  }
  
  :deep(.dialog-footer) {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  </style>  